import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-autorisation-ip',
  templateUrl: './autorisation-ip.component.html',
  styleUrls: ['./autorisation-ip.component.css']
})
export class AutorisationIPComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
